import React, { useCallback, useEffect, useState } from "react";
import api from "../api/client";

const EMPTY_FORM = {
  organization_name: "",
  shop_name: "Main Shop",
  admin_email: "",
  admin_password: "",
  admin_full_name: "",
};

export default function OrganizationsPage() {
  const [organizations, setOrganizations] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (message) {
      const t = setTimeout(() => setMessage(""), 6000);
      return () => clearTimeout(t);
    }
  }, [message]);

  useEffect(() => {
    if (error) {
      const t = setTimeout(() => setError(""), 6000);
      return () => clearTimeout(t);
    }
  }, [error]);

  const fetchOrganizations = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/organizations");
      setOrganizations(res.data);
    } catch (err) {
      setError("Failed to load organizations");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    setError("");
    try {
      const res = await api.post("/organizations", {
        ...form,
        admin_full_name: form.admin_full_name || null,
      });
      setMessage(`Organization "${res.data.name}" created with admin ${form.admin_email}.`);
      setForm(EMPTY_FORM);
      fetchOrganizations();
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to create organization");
    }
    setSubmitting(false);
  };

  return (
    <div className="content-grid">
      <div className="card form-card">
        <h2>Onboard Organization</h2>
        <form onSubmit={handleSubmit} className="product-form">
          <input
            type="text"
            name="organization_name"
            placeholder="Organization name"
            value={form.organization_name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="shop_name"
            placeholder="First shop name"
            value={form.shop_name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="admin_email"
            placeholder="Admin email"
            value={form.admin_email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="admin_password"
            placeholder="Admin password"
            value={form.admin_password}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="admin_full_name"
            placeholder="Admin full name (optional)"
            value={form.admin_full_name}
            onChange={handleChange}
          />
          <div className="form-actions">
            <button className="btn" type="submit" disabled={submitting}>
              Create Organization
            </button>
          </div>
        </form>
        {message && <div className="success-msg">{message}</div>}
        {error && <div className="error-msg">{error}</div>}
      </div>

      <div className="card list-card">
        <h2>Organizations</h2>
        {loading ? (
          <div className="loader">Loading...</div>
        ) : (
          <div className="scroll-x">
            <table className="product-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Slug</th>
                  <th>Shops</th>
                  <th>Users</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map((org) => (
                  <tr key={org.id}>
                    <td>{org.id}</td>
                    <td className="name-cell">{org.name}</td>
                    <td>{org.slug}</td>
                    <td>{org.shop_count}</td>
                    <td>{org.user_count}</td>
                    <td>{new Date(org.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
                {organizations.length === 0 && (
                  <tr>
                    <td colSpan={6} className="empty">
                      No organizations yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
